/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Pause_While_Typing_HelpInputs */

const en_options_editor_pause_while_typing_help = /** @type {(inputs: Options_Editor_Pause_While_Typing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically pause/resume playback when transcribing.`)
};

const fr_options_editor_pause_while_typing_help = /** @type {(inputs: Options_Editor_Pause_While_Typing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre automatiquement en pause/reprendre la lecture lors de la transcription.`)
};

const de_options_editor_pause_while_typing_help = /** @type {(inputs: Options_Editor_Pause_While_Typing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Wiedergabepause/Wiedergabefortsetzung beim Transkribieren.`)
};

const it_options_editor_pause_while_typing_help = /** @type {(inputs: Options_Editor_Pause_While_Typing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metti in pausa/riprendi automaticamente la riproduzione durante la trascrizione.`)
};

const ru_options_editor_pause_while_typing_help = /** @type {(inputs: Options_Editor_Pause_While_Typing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая приостановка/возобновление воспроизведения при транскрибировании.`)
};

const es_options_editor_pause_while_typing_help = /** @type {(inputs: Options_Editor_Pause_While_Typing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausa/reanuda automáticamente la reproducción al transcribir.`)
};

const zh_cn2_options_editor_pause_while_typing_help = /** @type {(inputs: Options_Editor_Pause_While_Typing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录时自动暂停/恢复播放。`)
};

const ja_options_editor_pause_while_typing_help = /** @type {(inputs: Options_Editor_Pause_While_Typing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転記時に再生を自動的に一時停止/再開します。`)
};

const hi_options_editor_pause_while_typing_help = /** @type {(inputs: Options_Editor_Pause_While_Typing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रांसक्रिप्शन करते समय प्लेबैक स्वचालित रूप से रुक जाएगा/फिर से शुरू हो जाएगा।`)
};

const pt_pt2_options_editor_pause_while_typing_help = /** @type {(inputs: Options_Editor_Pause_While_Typing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausar/retomar automaticamente a reprodução durante a transcrição.`)
};

/**
* | output |
* | --- |
* | "Automatically pause/resume playback when transcribing." |
*
* @param {Options_Editor_Pause_While_Typing_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_pause_while_typing_help = /** @type {((inputs?: Options_Editor_Pause_While_Typing_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Pause_While_Typing_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_pause_while_typing_help(inputs)
	if (locale === "de") return de_options_editor_pause_while_typing_help(inputs)
	if (locale === "it") return it_options_editor_pause_while_typing_help(inputs)
	if (locale === "ru") return ru_options_editor_pause_while_typing_help(inputs)
	if (locale === "es") return es_options_editor_pause_while_typing_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_pause_while_typing_help(inputs)
	if (locale === "ja") return ja_options_editor_pause_while_typing_help(inputs)
	if (locale === "hi") return hi_options_editor_pause_while_typing_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_pause_while_typing_help(inputs)
	return en_options_editor_pause_while_typing_help(inputs)
});